import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SearchState {
  input: string;
  isLoading: boolean;
}

const initialState: SearchState = {
  input: '',
  isLoading: false,
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearch(state, action: PayloadAction<string>) {
      state.input = action.payload;
    },

    setSearchLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },

    resetSearch(state) {
      state.input = '';
      state.isLoading = false;
    },
  },
});

export const { setSearch, setSearchLoading, resetSearch } = searchSlice.actions;

export default searchSlice.reducer;
